module.exports = __webpack_public_path__ + "img/googleoauth.55de6125.svg";